export default __webpack_public_path__ + "static/Lou-54a632dbaaa441b4267b3ee704ab5729.webp";